/* eslint-disable react/prop-types */
import CardSliderPartnerComponent from "./card-slider-partner";
import { useHistory } from "react-router-dom";
function CardSliderPartner({ item }) {
  const history = useHistory();

  const { name, imageSamll } = item;
  const handleClick = () => {
    history.push(`/partner/${name}`);
  };

  return (
    <CardSliderPartnerComponent image={imageSamll} onClick={handleClick} />
  );
}

export default CardSliderPartner;
